<template>
  <div class="contract-container">
    <div
      v-if="contractId"
      @click="showContractHistory = !showContractHistory"
      :class="{ 'active-contract-card': showContractHistory }"
      class="contract-card"
    >
      <div>Contrato: {{ contractId }}</div>

      <Icon :icon="contractCardIcon" class="card-icon" />
    </div>

    <div v-if="showContractHistory" class="contract-history">
      <div class="log-header">
        <div class="date-header">Data</div>

        <div class="cards-header">Histórico de atividades</div>
      </div>

      <div v-for="(log, index) in contractHistory" :key="index" class="logs-content-holder">
        <div class="logs-timeline">
          <div class="pre-timeline-line" />

          <div class="rounded-holder" :class="`bg-${typeColor(log.type.id)}`">
            <Icon :icon="typeIcon(log.type.id)" class="timeline-type-icon" />
          </div>

          <div class="timeline-date">
            {{
              $service.dateFormat(
                log.created_at,
                (currentFormat = "YYYY-MM-DD HH:mm"),
                (toFormat = "DD/MM/YYYY"),
              )
            }}
          </div>

          <div class="timeline-time">
            {{
              $service.dateFormat(
                log.created_at,
                (currentFormat = "YYYY-MM-DD HH:mm"),
                (toFormat = "HH[h]mm"),
              )
            }}
          </div>

          <i class="icon-circle" :class="`bg-${typeColor(log.type.id)} ${typeColor(log.type.id)}`" />

          <div class="timeline-line" />
        </div>

        <div class="cards-holder">
          <div class="contract-log-card">
            <div class="log-title"><b> Ação: </b> {{ log.type?.description || "Sem ação" }}</div>

            <div class="log-description">
              <b> Descrição: </b> {{ log.event_description || "Sem descrição" }}
            </div>

            <div v-if="log.occurrence" class="log-occurrence"><b> Ocorrência: </b> {{ log.occurrence }}</div>

            <div class="log-responsible">
              <b> Responsável: </b> {{ log.responsible?.name || "Sem responsável" }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="erpContractId"
      @click="showErpContractHistory = !showErpContractHistory"
      :class="{ 'active-contract-card': showErpContractHistory }"
      class="contract-card"
    >
      <div>Contrato: {{ erpContractId }}</div>

      <Icon :icon="contractErpCardIcon" class="card-icon" />
    </div>

    <div v-if="showErpContractHistory" class="contract-history">
      <div class="log-header">
        <div class="date-header">Data</div>

        <div class="cards-header">Histórico de atividades</div>
      </div>

      <div v-for="(log, index) in erpContractHistory" :key="index" class="logs-content-holder">
        <div class="logs-timeline">
          <div class="pre-timeline-line" />

          <div class="rounded-holder" :class="`bg-${typeColor(log.type.id)}`">
            <Icon :icon="typeIcon(log.type.id)" class="timeline-type-icon" />
          </div>

          <div class="timeline-date">
            {{
              $service.dateFormat(
                log.created_at,
                (currentFormat = "YYYY-MM-DD HH:mm"),
                (toFormat = "DD/MM/YYYY"),
              )
            }}
          </div>

          <div class="timeline-time">
            {{
              $service.dateFormat(
                log.created_at,
                (currentFormat = "YYYY-MM-DD HH:mm"),
                (toFormat = "HH[h]mm"),
              )
            }}
          </div>

          <i class="icon-circle" :class="`bg-${typeColor(log.type.id)} ${typeColor(log.type.id)}`" />

          <div class="timeline-line" />
        </div>

        <div class="cards-holder">
          <div class="contract-log-card">
            <div class="log-title"><b> Ação: </b> {{ log.type?.description || "Sem ação" }}</div>

            <div class="log-description">
              <b> Descrição: </b> {{ log.event_description || "Sem descrição" }}
            </div>

            <div v-if="log.occurrence" class="log-occurrence"><b> Ocorrência: </b> {{ log.occurrence }}</div>

            <div class="log-responsible">
              <b> Responsável: </b> {{ log.responsible?.name || "Sem responsável" }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";

export default {
  name: "ContractHistory",

  components: {
    Icon,
  },

  props: {
    contractId: {
      type: Number,
      required: false,
      default: null,
    },

    erpContractId: {
      type: Number,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      hasRequest: false,
      hasErpRequest: false,

      showContractHistory: false,
      showErpContractHistory: false,

      contractHistory: null,
      erpContractHistory: null,

      types: [
        { id: 1, icon: "mdi:cog-sync", color: "blue" },
        { id: 2, icon: "mdi:cancel", color: "red" },
        { id: 3, icon: "mdi:cancel", color: "red" },
        { id: 4, icon: "mdi:cash-multiple", color: "red" },
        { id: 5, icon: "mdi:cash-multiple", color: "red" },
        { id: 6, icon: "mdi:cog-sync", color: "blue" },
        { id: 7, icon: "mdi:account-alert", color: "yellow" },
        { id: 8, icon: "mdi:account-alert", color: "yellow" },
        { id: 9, icon: "mdi:account-alert", color: "yellow" },
        { id: 10, icon: "mdi:cash-multiple", color: "red" },
        { id: 11, icon: "mdi:cancel", color: "red" },
        { id: 12, icon: "mdi:cancel", color: "red" },
        { id: 13, icon: "mdi:school", color: "purple" },
        { id: 14, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 15, icon: "mdi:phone", color: "blue" },
        { id: 16, icon: "mdi:file-document-outline", color: "green" },
        { id: 17, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 20, icon: "mdi:bullhorn", color: "light-blue" },
        { id: 21, icon: "mdi:file-document-outline", color: "green" },
        { id: 22, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 23, icon: "mdi:cash-multiple", color: "red" },
        { id: 24, icon: "mdi:account-alert", color: "yellow" },
        { id: 25, icon: "mdi:phone", color: "blue" },
        { id: 26, icon: "mdi:school", color: "purple" },
        { id: 27, icon: "mdi:bullhorn", color: "light-blue" },
        { id: 28, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 29, icon: "mdi:file-document-outline", color: "green" },
        { id: 30, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 31, icon: "mdi:school", color: "purple" },
        { id: 32, icon: "mdi:cash-multiple", color: "red" },
        { id: 33, icon: "mdi:file-document-outline", color: "green" },
        { id: 34, icon: "mdi:phone", color: "blue" },
        { id: 35, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 36, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 37, icon: "mdi:dots-horizontal", color: "blue" },
        { id: 38, icon: "mdi:cash-multiple", color: "red" },
        { id: 39, icon: "mdi:cash-multiple", color: "red" },
        { id: 40, icon: "mdi:scale-balance", color: "red" },
        { id: 41, icon: "mdi:dots-horizontal", color: "blue" },
        { id: 42, icon: "mdi:cash-multiple", color: "red" },
        { id: 43, icon: "mdi:dots-horizontal", color: "blue" },
        { id: 44, icon: "mdi:school", color: "purple" },
        { id: 45, icon: "mdi:cash-multiple", color: "red" },
        { id: 46, icon: "mdi:file-document-outline", color: "green" },
        { id: 47, icon: "mdi:file-document-outline", color: "green" },
        { id: 48, icon: "mdi:school", color: "purple" },
        { id: 49, icon: "mdi:cash-multiple", color: "red" },
        { id: 50, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 51, icon: "mdi:phone", color: "blue" },
        { id: 52, icon: "mdi:school", color: "purple" },
        { id: 53, icon: "mdi:dots-horizontal", color: "blue" },
        { id: 54, icon: "mdi:dots-horizontal", color: "blue" },
        { id: 55, icon: "mdi:bullhorn", color: "light-blue" },
        { id: 56, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 57, icon: "mdi:bullhorn", color: "light-blue" },
        { id: 58, icon: "mdi:school", color: "purple" },
        { id: 59, icon: "mdi:cash-multiple", color: "red" },
        { id: 60, icon: "mdi:bullhorn", color: "light-blue" },
        { id: 61, icon: "mdi:bullhorn", color: "light-blue" },
        { id: 62, icon: "mdi:phone", color: "blue" },
        { id: 63, icon: "mdi:school", color: "purple" },
        { id: 64, icon: "mdi:phone", color: "blue" },
        { id: 65, icon: "mdi:phone", color: "blue" },
        { id: 66, icon: "mdi:bullhorn", color: "light-blue" },
        { id: 67, icon: "mdi:account-alert", color: "yellow" },
        { id: 68, icon: "mdi:cancel", color: "red" },
        { id: 69, icon: "mdi:account-alert", color: "yellow" },
        { id: 70, icon: "mdi:account-alert", color: "yellow" },
        { id: 71, icon: "mdi:account-alert", color: "yellow" },
        { id: 72, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 73, icon: "mdi:account-alert", color: "yellow" },
        { id: 74, icon: "mdi:file-document-outline", color: "green" },
        { id: 75, icon: "mdi:cash-multiple", color: "red" },
        { id: 76, icon: "mdi:cash-multiple", color: "red" },
        { id: 77, icon: "mdi:cash-multiple", color: "red" },
        { id: 78, icon: "mdi:phone", color: "blue" },
        { id: 79, icon: "mdi:file-document-outline", color: "green" },
        { id: 80, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 81, icon: "mdi:cancel", color: "red" },
        { id: 82, icon: "mdi:cash-multiple", color: "red" },
        { id: 83, icon: "mdi:file-document-outline", color: "green" },
        { id: 84, icon: "mdi:file-document-outline", color: "green" },
        { id: 85, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 86, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 87, icon: "mdi:account-alert", color: "yellow" },
        { id: 88, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 89, icon: "mdi:school", color: "purple" },
        { id: 90, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 91, icon: "mdi:cash-multiple", color: "red" },
        { id: 92, icon: "mdi:cash-multiple", color: "red" },
        { id: 93, icon: "mdi:file-document-outline", color: "green" },
        { id: 94, icon: "mdi:account-alert", color: "yellow" },
        { id: 95, icon: "mdi:cash-multiple", color: "red" },
        { id: 96, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 97, icon: "mdi:file-document-outline", color: "green" },
        { id: 98, icon: "mdi:school", color: "purple" },
        { id: 99, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 100, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 101, icon: "mdi:school", color: "purple" },
        { id: 110, icon: "mdi:cash-multiple", color: "red" },
        { id: 111, icon: "mdi:cash-multiple", color: "red" },
        { id: 112, icon: "mdi:account-alert", color: "yellow" },
        { id: 113, icon: "mdi:school", color: "purple" },
        { id: 114, icon: "mdi:cash-multiple", color: "red" },
        { id: 115, icon: "mdi:account-alert", color: "yellow" },
        { id: 116, icon: "mdi:account-alert", color: "yellow" },
        { id: 117, icon: "mdi:account-alert", color: "yellow" },
        { id: 118, icon: "mdi:phone", color: "blue" },
        { id: 119, icon: "mdi:cash-multiple", color: "red" },
        { id: 120, icon: "mdi:file-document-outline", color: "green" },
        { id: 121, icon: "mdi:cash-multiple", color: "red" },
        { id: 122, icon: "mdi:phone", color: "blue" },
        { id: 123, icon: "mdi:phone", color: "blue" },
        { id: 124, icon: "mdi:cash-multiple", color: "red" },
        { id: 125, icon: "mdi:cash-multiple", color: "red" },
        { id: 126, icon: "mdi:cash-multiple", color: "red" },
        { id: 127, icon: "mdi:scale-balance", color: "red" },
        { id: 128, icon: "mdi:cash-multiple", color: "red" },
        { id: 129, icon: "mdi:cash-multiple", color: "red" },
        { id: 130, icon: "mdi:bullhorn", color: "light-blue" },
        { id: 131, icon: "mdi:cancel", color: "red" },
        { id: 132, icon: "mdi:cash-multiple", color: "red" },
        { id: 133, icon: "mdi:file-document-outline", color: "green" },
        { id: 134, icon: "mdi:file-document-outline", color: "green" },
        { id: 135, icon: "mdi:file-document-outline", color: "green" },
        { id: 136, icon: "mdi:scale-balance", color: "red" },
        { id: 137, icon: "mdi:phone", color: "blue" },
        { id: 138, icon: "mdi:phone", color: "blue" },
        { id: 139, icon: "mdi:bullhorn", color: "light-blue" },
        { id: 140, icon: "mdi:school", color: "purple" },
        { id: 141, icon: "mdi:bullhorn", color: "light-blue" },
        { id: 142, icon: "mdi:cash-multiple", color: "red" },
        { id: 143, icon: "mdi:bullhorn", color: "light-blue" },
        { id: 144, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 145, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 146, icon: "mdi:account-alert", color: "yellow" },
        { id: 147, icon: "mdi:school", color: "purple" },
        { id: 148, icon: "mdi:bullhorn", color: "light-blue" },
        { id: 149, icon: "mdi:scale-balance", color: "red" },
        { id: 150, icon: "mdi:school", color: "purple" },
        { id: 151, icon: "mdi:cash-multiple", color: "red" },
        { id: 152, icon: "mdi:school", color: "purple" },
        { id: 153, icon: "mdi:phone", color: "blue" },
        { id: 154, icon: "mdi:bullhorn", color: "light-blue" },
        { id: 155, icon: "mdi:phone", color: "blue" },
        { id: 156, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 157, icon: "mdi:bullhorn", color: "light-blue" },
        { id: 158, icon: "mdi:bullhorn", color: "light-blue" },
        { id: 159, icon: "mdi:school", color: "purple" },
        { id: 160, icon: "mdi:cash-multiple", color: "red" },
        { id: 161, icon: "mdi:cash-multiple", color: "red" },
        { id: 162, icon: "mdi:calendar-clock", color: "light-blue" },
        { id: 163, icon: "mdi:cash-multiple", color: "red" },
        { id: 164, icon: "mdi:cash-multiple", color: "red" },
        { id: 165, icon: "mdi:school", color: "purple" },
        { id: 166, icon: "mdi:phone", color: "blue" },
        { id: 167, icon: "mdi:phone", color: "blue" },
        { id: 168, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 169, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 170, icon: "mdi:dots-horizontal", color: "blue" },
        { id: 171, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 172, icon: "mdi:school", color: "purple" },
        { id: 173, icon: "mdi:school", color: "purple" },
        { id: 174, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 175, icon: "mdi:cash-multiple", color: "red" },
        { id: 176, icon: "mdi:dots-horizontal", color: "blue" },
        { id: 177, icon: "mdi:school", color: "purple" },
        { id: 178, icon: "mdi:dots-horizontal", color: "blue" },
        { id: 179, icon: "mdi:cash-multiple", color: "red" },
        { id: 180, icon: "mdi:phone", color: "blue" },
        { id: 181, icon: "mdi:cash-multiple", color: "red" },
        { id: 182, icon: "mdi:cash-multiple", color: "red" },
        { id: 183, icon: "mdi:cash-multiple", color: "red" },
        { id: 184, icon: "mdi:cash-multiple", color: "red" },
        { id: 185, icon: "mdi:cash-multiple", color: "red" },
        { id: 186, icon: "mdi:cash-multiple", color: "red" },
        { id: 187, icon: "mdi:phone", color: "blue" },
        { id: 188, icon: "mdi:file-document-outline", color: "green" },
        { id: 189, icon: "mdi:file-document-outline", color: "green" },
        { id: 190, icon: "mdi:bullhorn", color: "light-blue" },
        { id: 191, icon: "mdi:file-document-outline", color: "green" },
        { id: 192, icon: "mdi:file-document-outline", color: "green" },
        { id: 193, icon: "mdi:file-document-outline", color: "green" },
        { id: 194, icon: "mdi:file-document-outline", color: "green" },
        { id: 195, icon: "mdi:file-document-outline", color: "green" },
        { id: 196, icon: "mdi:file-document-outline", color: "green" },
        { id: 197, icon: "mdi:file-document-outline", color: "green" },
        { id: 198, icon: "mdi:file-document-outline", color: "green" },
        { id: 199, icon: "mdi:file-document-outline", color: "green" },
        { id: 200, icon: "mdi:file-document-outline", color: "green" },
        { id: 201, icon: "mdi:school", color: "purple" },
        { id: 202, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 203, icon: "mdi:file-document-outline", color: "green" },
        { id: 204, icon: "mdi:file-document-outline", color: "green" },
        { id: 205, icon: "mdi:file-document-outline", color: "green" },
        { id: 206, icon: "mdi:file-document-outline", color: "green" },
        { id: 207, icon: "mdi:file-document-outline", color: "green" },
        { id: 208, icon: "mdi:file-document-outline", color: "green" },
        { id: 209, icon: "mdi:file-document-outline", color: "green" },
        { id: 210, icon: "mdi:account-alert", color: "yellow" },
        { id: 211, icon: "mdi:file-document-outline", color: "green" },
        { id: 212, icon: "mdi:file-document-outline", color: "green" },
        { id: 213, icon: "mdi:cash-multiple", color: "red" },
        { id: 214, icon: "mdi:cash-multiple", color: "red" },
        { id: 215, icon: "mdi:file-document-outline", color: "green" },
        { id: 216, icon: "mdi:clipboard-text-outline", color: "blue" },
        { id: 217, icon: "mdi:briefcase-account", color: "green" },
        { id: 218, icon: "mdi:briefcase-account", color: "green" },
        { id: 219, icon: "mdi:briefcase-account", color: "green" },
        { id: 220, icon: "mdi:briefcase-account", color: "green" },
        { id: 221, icon: "mdi:cancel", color: "red" },
        { id: 222, icon: "mdi:scale-balance", color: "red" },
        { id: 223, icon: "mdi:scale-balance", color: "red" },
        { id: 224, icon: "mdi:cog-sync", color: "blue" },
      ],
    };
  },

  computed: {
    contractCardIcon() {
      if (this.hasRequest) return "eos-icons:loading";

      return this.showContractHistory ? "mdi:chevron-up" : "mdi:chevron-down";
    },

    contractErpCardIcon() {
      if (this.hasErpRequest) return "eos-icons:loading";

      return this.showErpContractHistory ? "mdi:chevron-up" : "mdi:chevron-down";
    },
  },

  created() {
    if (this.contractId) this.fetchContractHistory(this.contractId);

    if (this.erpContractId) this.fetchErpContractHistory(this.erpContractId);
  },

  methods: {
    typeIcon(action) {
      const current = this.types.find((a) => a.id == action);

      if (!current) return "mdi:clipboard-text-outline";

      return current.icon;
    },

    typeColor(action) {
      const current = this.types.find((a) => a.id == action);

      if (!current) return "blue";

      return current.color;
    },

    fetchContractHistory(contractId) {
      this.hasRequest = true;

      const payload = {
        id: contractId,
      };

      this.$store
        .dispatch("opportunityStore/fetchContractHistory", payload)
        .then((response) => {
          console.log("Contract history response:", response.data);

          this.contractHistory = response.data;

          if (!this.erpContractId) this.showContractHistory = true;
        })
        .finally(() => {
          this.hasRequest = false;
        });
    },

    fetchErpContractHistory(erpContractId) {
      this.hasErpRequest = true;

      const payload = {
        id: erpContractId,
        params: {
          is_remote_id: true,
        },
      };

      this.$store
        .dispatch("opportunityStore/fetchContractHistory", payload)
        .then((response) => {
          console.log("ERP Contract history response:", response.data);

          this.erpContractHistory = response.data;

          if (!this.contractId) this.showErpContractHistory = true;
        })
        .finally(() => {
          this.hasErpRequest = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.contract-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  width: 100%;

  .contract-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    top: 0;
    width: 100%;
    padding: 1rem;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    background: #ffffff;
    color: #31333f;
    cursor: pointer;

    .card-icon {
      font-size: 24px;
    }
  }

  .active-contract-card {
    position: sticky;
    border-bottom: none;
  }

  .contract-history {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 15px 10px;

    .log-header {
      display: flex;
      align-items: center;
      text-align: center;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      width: 100%;
      gap: 10px;
      margin-bottom: 20px;
      color: #31333f;

      .date-header {
        min-width: 90px;
      }

      .cards-header {
        width: 100%;
      }
    }

    .logs-content-holder {
      display: grid;
      grid-template-columns: 90px 1fr;
      align-items: flex-start;
      gap: 10px;
      width: 100%;
      overflow: hidden;

      .logs-timeline {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
        width: 90px;

        .rounded-holder {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 18px;
          min-width: 40px;
          min-height: 40px;
          border-radius: 6px;
          color: #ffffff;

          .timeline-type-icon {
            font-size: 18px;
          }
        }

        .timeline-date {
          font-weight: 500;
          font-size: 14px;
          line-height: 21px;
          color: #212525;
        }

        .timeline-time {
          font-weight: 600;
          color: #999999;
        }

        .icon-circle {
          border-radius: 100%;
          border: 3px solid #c4c4c4;
        }

        .pre-timeline-line {
          height: 10px;
          width: 1px;
          border-right: 2px solid #c4c4c4;
        }

        .timeline-line {
          height: 100%;
          width: 1px;
          border-right: 2px solid #c4c4c4;
        }

        .bg-purple {
          background-color: #9160de;
        }
        .bg-red {
          background-color: #ff2c55;
        }
        .bg-light-blue {
          background-color: #38a7ff;
        }
        .bg-blue {
          background-color: #046af3;
        }
        .bg-green {
          background-color: #2ed47a;
        }
        .bg-yellow {
          background-color: #f8aa00;
        }
        .bg-orange {
          color: #f8aa00;
        }

        .purple {
          color: #9160de;
        }
        .red {
          color: #ff2c55;
        }
        .light-blue {
          color: #38a7ff;
        }
        .blue {
          color: #046af3;
        }
        .green {
          color: #2ed47a;
        }
        .yellow {
          color: #f8aa00;
        }
        .orange {
          color: #f8aa00;
        }
      }

      .cards-holder {
        max-width: 100%;
        overflow: hidden;

        .contract-log-card {
          display: flex;
          flex-direction: column;
          word-break: break-word !important;
          border-radius: 16px;
          margin-bottom: 15px;
          border: 1px solid #d2d2d2;
          box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
          overflow: hidden;

          .log-title {
            padding: 10px;
            border-bottom: 1px solid #d2d2d2;
            color: #31333f;
          }

          .log-description {
            padding: 10px;
            border-bottom: 1px solid #d2d2d2;
            color: #31333f;
          }

          .log-occurrence {
            padding: 10px;
            border-bottom: 1px solid #d2d2d2;
            color: #31333f;
          }

          .log-responsible {
            color: #31333f;
            padding: 10px;
          }
        }
      }
    }
  }

  .contract-history > * {
    flex-shrink: 0;
  }
}
</style>
